import { Box, lighten, Typography, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";

const DiagnosisSummary = ({ diag_code_details }) => {
  const theme = useTheme();
  const rows = diag_code_details.map((item, index) => ({
    id: index,
    code: item.code,
    description: item.description,
    included: item.included_in_score,
  }));

  const columns = [
    {
      field: "code",
      headerName: "Diagnosis Code",
      flex: 1,
      headerClassName: "header",
    },
    {
      field: "description",
      headerName: "Diagnosis Description",
      flex: 3,
      headerClassName: "header",
    },
    {
      field: "included",
      headerName: "Included in Recommended Score",
      flex: 1,
      headerClassName: "header",
      renderCell: (params) => (
        <Typography color={params.value === "Yes" ? "green" : "red"}>
          {params.value}
        </Typography>
      ),
    },
  ];

  return (
    <Box mt={4} m={2}>
      <Typography variant="h6" gutterBottom>
        Diagnosis Code Summary
      </Typography>
      <DataGrid
        autoHeight
        rows={rows}
        columns={columns}
        pageSize={5}
        disableRowSelectionOnClick
        sx={{
          "& .header": {
            backgroundColor: lighten(theme.palette.primary.main, 0.6),
            color: "white",
            fontWeight: "bold",
          },
        }}
      />
    </Box>
  );
};

export default DiagnosisSummary;
